import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getInvoicesURL, getInvoiceURL } from '../api';
import moment from 'jalali-moment'

// initial state
export const initialState = {
  loading: false,
  error: false,
  currentPageIndex : 0,
  hasMore : true,
  items: [],
 
  fetchPermission : true,//برای مواقعی که بک زده میشه از یک فاکتور به فهرست نمیخواهیم مجدد لود شود

  selectedInvoice : {},
  selectedInvoiceId : '',

  searchKey : '',
  searchKey_fromdate : '',
  searchKey_todate : ''
};

// our slice
const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    setInvoiceLoading: (state) => {
      state.loading = true;
    },
    setInvoiceSearchKey : (state, { payload }) =>{
      state.searchKey = payload;
    },
    setInvoiceSearchKeyFromdate : (state, { payload }) =>{
      state.searchKey_fromdate = payload;
    },
    setInvoiceSearchKeyTodate : (state, { payload }) =>{
      state.searchKey_todate = payload;
    },
    setInvoiceItems: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.items.push(...payload);
      if(payload.length === 0){
        state.hasMore = false;
      }
      console.log("newItems count is " + (payload.length));
      state.currentPageIndex++;
    },
    setSelectedInvoiceId: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      console.log("selectedInvoiceId");
      state.fetchPermission = false;// یعنی وارد یک فاکتور شدیم و دیگه مجدد لود نکنه اطلاعات رو
      state.selectedInvoiceId = payload;
    },
    setSelectedInvoice: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.selectedInvoice = payload;
      state.selectedInvoiceId = payload.ID;
      state.fetchPermission = false;
    },
    setInvoiceError: (state) => {
      state.error = true;
    },
    clearInvoiceItems: (state) => {
      state.items = [];
      state.currentPageIndex = 0;
      state.selectedInvoice = {};
      state.selectedInvoiceId = '';
    },
    clearSelectedInvoice: (state) => {
      state.selectedInvoice = {};
      state.selectedInvoiceId = '';
    },
    clearInvoiceFilters: (state) => {
      state.searchKey = '';
      state.searchKey_fromdate = '';
      state.searchKey_todate = '';
    },
    clearInvoiceData: (state) => {
      
      state.loading = false;
      state.error = false;
      state.currentPageIndex = 0;
      state.items = [];
      state.selectedInvoice = {};
      state.selectedInvoiceId = '';
      state.hasMore = true;
      state.searchKey  = '';
      state.searchKey_fromdate  = '';
      state.searchKey_todate  = '';
      state.fetchPermission = true;

    }
  },
});

// export the actions
export const { setInvoiceLoading, setInvoiceItems, setInvoiceError, clearInvoiceData,setInvoiceSearchKey, setInvoiceSearchKeyFromdate, setInvoiceSearchKeyTodate,clearInvoiceItems ,clearInvoiceFilters, setSelectedInvoice , setSelectedInvoiceId, clearSelectedInvoice} = invoicesSlice.actions;

// export the selector (".items" being same as in slices/index.js's "items: something")
export const invoiceItemsSelector = (state) => state.items;

// export the default reducer
export default invoicesSlice.reducer;


// fetch all items
export function fetchInvoices(input) {
  return async (dispatch) => {
    console.log("input");
console.log(input);

    var _fd = "";
    _fd = moment.from(input.fromdate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
    
    var _td = "";
    _td = moment.from(input.todate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);

    if(input.pageindex === 0)
      dispatch(clearInvoiceItems());

    if(input.hasMore){
      dispatch(setInvoiceLoading());
      await axios.post(getInvoicesURL()+'?saleDocType=2&searchKey='+input.searchkey+'&searchNumber='+''+'&pageIndex='+input.pageindex+'&fromDate='+_fd+'&toDate='+_td+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          dispatch(setInvoiceItems(response.data));
      }).catch(function (err) {
        dispatch(setInvoiceError());
      }).finally(()=> {

      });
  }
  };
}


// fetch all items
export function fetchInvoice(input) {
  return async (dispatch) => {

      dispatch(setInvoiceLoading());
      await axios.post(getInvoiceURL()+'?saleDocType=2&saleDocId='+input.saleDocId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          dispatch(setSelectedInvoice(response.data));
      }).catch(function (err) {
        dispatch(setInvoiceError());
      }).finally(()=> {

      });
  }
};

export function clearInvoices() {
  return async (dispatch) => {

      dispatch(clearInvoiceData());
   
  };
}